var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.busy,"color":"primary"},on:{"click":_vm.exportOrders}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("cloud_download")]),_vm._v(_vm._s(_vm.$t('actions.export')))],1)}
var staticRenderFns = []

export { render, staticRenderFns }